window.onload = () => {
    document.body.classList.add("loaded");
 };

const getCart = () => fetch(window.Shopify.routes.root + "cart.js").then((e) => e.json());
function addItemToCart(e, t, r) {
    fetch("/cart/add.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" }, body: JSON.stringify({ items: [{ id: e, quantity: t }] }) })
        .then((e) => (r(), e.json()))
        .catch((e) => {
            console.error("Error:", e);
        });
}
function updateItemInCart(e, t, r) {
    fetch("/cart/update.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" }, body: JSON.stringify({ updates: { [e]: t } }) })
        .then((e) => (r(), e.json()))
        .catch((e) => {
            console.error("Error:", e);
        });
}
  const searchForm = document.querySelector(".search-bar");
  if(searchForm){
    searchForm.addEventListener("click", function (e) {
    	if(e.target.closest(".search-bar__input")){
          !searchForm.classList.contains("is-expanded") ? searchForm.classList.add("is-expanded") : null;
        }
        if(e.target.closest(".new-results__items li")){
          const searchText = e.target.closest(".new-results__items li").innerText.toLowerCase();
          window.location.assign('/search?q=' + searchText);
        }
    });
  }

// document.addEventListener("loaded", function () {
window.onload = () => {


  
    function e(e, t) {
        let r = Number(e.dataset.rawPrice),
            s = e.querySelector(".price"),
            i = e.querySelector(".price.price--compare"),
            l = r;
        if (
            t &&
            (t.forEach(function (e) {
                let t = Number(e.dataset.price);
                e.checked && (l += t);
            }),
            (s.innerHTML = (l / 100).toFixed(2).toString().replace(".", ",")),
            i)
        ) {
            let o = Number(e.dataset.rawComparePrice);
            t.forEach(function (e) {
                let t = Number(e.dataset.comparePrice);
                e.checked && (o += t);
            }),
                (i.innerHTML = (o / 100).toFixed(2).toString().replace(".", ","));
        }
    }
    // if (document.body.classList.contains("loaded")) {
               var t = document.querySelectorAll('[name="upsell-product"]'),
            r = document.querySelectorAll(".prodUpsellForm"),
            s = document.querySelectorAll(".atcAddDynamicEl");
           function i(e) {
            let t = 0,
                r = [];
            return (
                e.forEach(function (e) {
                    var s = Number(e.dataset.price),
                        i = Number(e.dataset.relId);
                    e.checked && ((t += s), r.push({ id: i, quantity: 1 }));
                }),
                { price: t, items: r }
            );
        }
        t.forEach(function (e) {
            var r = e,
                s = r.dataset.relId,
                l = r.closest(".prodUpsell"),
                o = l.querySelector(".prodUpsellTotal"),
                n = l.querySelector('.prodUpsellCell[data-id="' + s + '"]');
            r.addEventListener("change", function () {
                let e = i(t).price / 100;
                r.checked ? n.classList.remove("d-none") : n.classList.add("d-none"), (o.innerHTML = e.toString().replace(".", ","));
            });
        }),
            r.forEach(function (e) {
                e.addEventListener("submit", function (t) {
                    var r = e.dataset.redirect,
                        s = i(e.querySelectorAll('[name="upsell-product"]')).items;
                    s &&
                        s.length &&
                        (t.preventDefault(),
                        fetch("/cart/add.js", { method: "post", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: s }) })
                            .then((e) => {
                                console.log(e.json()), (window.location.href = r);
                            })
                            .catch((e) => {
                                console.error("Error:", e);
                            }));
                });
            });
        var l = document.querySelectorAll(".upsellCheckbox");
        l &&
            l.forEach(function (t) {
                let r = t.closest(".productSidebar").querySelector(".priceWrapper"),
                    s = t.closest(".upsellCheckboxesWrapper"),
                    i = t.closest(".upsellCheckboxes").querySelectorAll(".upsellCheckbox"),
                    l = !!s && s.querySelectorAll(".upsellCheckboxes");
                t.addEventListener("change", () => {
                    var o = t.dataset.relId;
                    if (l.length > 1) {
                        let n = s.querySelectorAll('.upsellCheckboxes.d-none .upsellCheckbox[data-rel-id="' + o + '"]');
                        n &&
                            n.forEach(function (e) {
                                e.checked = t.checked;
                            });
                    }
                    e(r, i);
                });
            });
        var o = document.querySelectorAll(".productForm");
        o &&
            o.forEach(function (e) {
                let t = e.querySelector(".productATC");
                t &&
                    t.addEventListener("click", (t) => {
                        let r = window.SELECTED_VARIANT_ID,
                            s = e.querySelectorAll('.upsellCheckbox[data-sel-id="' + r + '"]:checked');
                        var l = i(s).items;
                        s &&
                            l &&
                            l.length &&
                            (t.preventDefault(),
                            fetch("/cart/add.js", { method: "post", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: l }) })
                                .then((t) => {
                                    console.log(t), e.submit();
                                })
                                .catch((e) => {
                                    console.error("Error:", e);
                                }));
                    });
            }),
            document.addEventListener("variant:changed", function (t) {
                var r = t.detail.variant,
                    s = document.querySelector(".priceWrapper"),
                    i = document.querySelectorAll(".variantDelivery"),
                    l = document.querySelectorAll('.variantDelivery[data-variant-id="' + r.id + '"]'),
                    o = document.querySelectorAll(".upsellCheckboxes"),
                    n = document.querySelector('.upsellCheckboxes[data-id="' + r.id + '"]');
                s && ((s.dataset.rawPrice = r.price), (window.SELECTED_VARIANT_ID = r.id)),
                    i &&
                        i.forEach(function (e) {
                            e.classList.add("d-none");
                        }),
                    l &&
                        l.forEach(function (e) {
                            e.classList.remove("d-none");
                        }),
                    o &&
                        o.forEach(function (e) {
                            e.classList.add("d-none"), e.classList.add("is-active");
                        }),
                    n && (n.classList.remove("d-none"), n.classList.remove("is-active")),
                    e(s, n.querySelectorAll(".upsellCheckbox"));
            }),
            s.forEach(function (e) {
                  let t = e.querySelector(".atcDynamicBtnAdd"),
                    r = e.querySelector(".atcAddDynamicBtnRmv");
                function s() {
                    getCart().then((e) => {
                        let t = document.querySelectorAll(".header__cart-count");
                        t &&
                            t.forEach((t) => {
                                t.innerHTML = e.item_count;
                            });
                    });
                }
                function i() {
                    e.classList.add("added"), s();
                }
                function l() {
                    e.classList.remove("added"), s();
                }
                t.addEventListener("click", function (e) {
                   console.log(t)
                    let r;
                    addItemToCart(t.dataset.variantId, t.dataset.quantity, i);
                }),
                    r.addEventListener("click", function (e) {
                        updateItemInCart(t.dataset.variantId, 0, l);
                    });
            });
    // }

};
var hideBlockIfEmpty = document.querySelectorAll(".hideBlockIfEmpty");
hideBlockIfEmpty &&
    hideBlockIfEmpty.forEach(function (e) {
        "" === e.querySelector(".hideBlockIfEmptyContent").innerHTML.trim() && e.classList.add("d-none");
    });
var reviewScore = document.querySelectorAll(".reviewScore");
reviewScore &&
    "undefined" != typeof REVIEW_SCORE &&
    reviewScore.forEach(function (e) {
        e.innerHTML = REVIEW_SCORE;
    });
var langSwitch = document.querySelectorAll("[data-switch-lang]");
langSwitch &&
    langSwitch.forEach((e) => {
        e.addEventListener("click", function () {
            fetch("https://spreadsheets.google.com/feeds/list/1VDNMeN2sFEuKcDaNuvn0Xt8FTsdCr7vqW3bd0AXor_E/od6/public/values?alt=json", { method: "GET" }).then((e) => {
                console.log(e.status, e.text);
            });
        });
    });
const atcBottomEdge = document.querySelectorAll(".atcBottomEdge");
function handleDocumentScrolledClass() {
    (window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop) > 0 ? document.documentElement.classList.add("is-scrolled") : document.documentElement.classList.remove("is-scrolled");
}
function isElemScrolledOutOfView(e) {
    e.forEach((e) => {
        let t = e.getBoundingClientRect(),
            r = document.body.scrollTop,
            s = t.top + r,         
            i = document.querySelector(".product-form__payment-container"),
             l = document.querySelector("#shopify-section-header").offsetHeight,
            top = s - window.innerHeight - i.offsetHeight;
        (r > s || top>0) ? (document.body.classList.add("is-atc-sticky"), window.innerWidth > 1e3 && (i.style.top = `${l}px`)) : (document.body.classList.remove("is-atc-sticky"), window.innerWidth > 1e3 && (i.style.top = 0));
           
    });
}
function announcementBarHeight (){
  const target = document.querySelector(".announcement-bar");
  
   if(target){
     let options = {
        root: null,
        rootMargin: '0px',
        threshold: 1
    }
      const intersectionCallback = (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
             // a = target.offsetHeight;
              // const top = document.querySelector(".product-form__payment-container").style.top.split("px")[0];
              const header = document.querySelector("#shopify-section-header").offsetHeight
              const newTop = header + target.offsetHeight;
              document.querySelector(".product-form__payment-container") ? document.querySelector(".product-form__payment-container").style.top = `${newTop}px` : null;
            }
            // } else{
            //   // document.querySelector(".product-form__payment-container").style.marginTop = `0px`
  
            // }
  
          });
        };
      const observer = new IntersectionObserver(intersectionCallback, options);
      observer.observe(target);
   }
}

atcBottomEdge &&
    (isElemScrolledOutOfView(atcBottomEdge), announcementBarHeight(),
    window.addEventListener("scroll", () => {
        isElemScrolledOutOfView(atcBottomEdge);
      announcementBarHeight();
    })),
    handleDocumentScrolledClass(),
    window.addEventListener("scroll", () => {
        handleDocumentScrolledClass();
    });
   
let sliderTag = null,
    sliderProduct = null,
    sliderIcons = null,
    sliderOffers = null,
    mediaQuerySizeLarge = 1e3,
    mediaQuerySize = 640;
function sliderTagInit() {
    document.querySelector(".swiper.tag-swiper") &&
        !sliderTag &&
        (sliderTag = new Swiper(".swiper.tag-swiper", { slidesPerView: "auto", spaceBetween: 11, scrollbar: { el: ".swiper.tag-swiper .swiper-scrollbar", draggable: !0, snapOnRelease: !0 }, on: {} }));
}
function sliderTagDestroy() {
    sliderTag && (console.log(sliderTag), sliderTag.destroy(), (sliderTag = null));
}
function sliderProductInit() {
    document.querySelector(".blog-sidebar-swiper") &&
        !sliderProduct &&
        (sliderProduct = new Swiper(".blog-sidebar-swiper", { slidesPerView: 1, spaceBetween: 20, scrollbar: { el: ".blog-sidebar-swiper .swiper-scrollbar", draggable: !0 }, on: {} }));
}
function sliderProductDestroy() {
    sliderProduct && (sliderProduct.destroy(), (sliderProduct = null));
}
function sliderIconsInit() {
    document.querySelector(".swiper-text-icons") && !sliderIcons && (sliderIcons = new Swiper(".swiper-text-icons", { slidesPerView: 1, spaceBetween: 20, scrollbar: { el: ".swiper-text-icons .swiper-scrollbar", draggable: !0 }, on: {} }));
}
function sliderIconsDestroy() {
    sliderIcons && (sliderIcons.destroy(), (sliderIcons = null));
}
function sliderOffersDestroy() {
    sliderOffers && (sliderOffers.destroy(), (sliderOffers = null));
}
function sliderOffersInit() {
    document.querySelector(".swiper.swiper-offers") &&
        !sliderOffers &&
        (sliderOffers = new Swiper(".swiper.swiper-offers", { slidesPerView: "auto", spaceBetween: 32, scrollbar: { el: ".swiper.swiper-offers .swiper-scrollbar", draggable: !0, snapOnRelease: !0 } }));
}
function initSliders() {
    document.querySelector(".swiper-upsells") &&
        new Swiper(".swiper-upsells", {
            observer: !0,
            observeParents: !0,
            slidesPerView: 3,
            spaceBetween: 16,
            speed: 800,
            navigation: { prevEl: ".pdp-upsells__swiper-buttons .swiper-button-prev", nextEl: ".pdp-upsells__swiper-buttons .swiper-button-next" },
            breakpoints: { 320: { slidesPerView: 1.15, spaceBetween: 10 }, 467: { slidesPerView: 1.8, spaceBetween: 16 }, 640: { slidesPerView: 3, spaceBetween: 16 } },
            on: {},
        }),
        document.querySelector(".swiper-products-list") &&
            new Swiper(".swiper-products-list", {
                observer: !0,
                observeParents: !0,
                slidesPerView: 3,
                spaceBetween: 16,
                speed: 800,
                scrollbar: { el: ".swiper-products-list .swiper-scrollbar", draggable: !0 },
                navigation: { prevEl: ".swiper-products-list .swiper-button-prev", nextEl: ".swiper-products-list  .swiper-button-next" },
                breakpoints: {
                    320: { slidesPerView: 1.15, spaceBetween: 10 },
                    467: { slidesPerView: 1.8, spaceBetween: 16 },
                    640: { slidesPerView: 2.8, spaceBetween: 17.5 },
                    991: { slidesPerView: 3.3, spaceBetween: 17.5 },
                    1200: { slidesPerView: 5, spaceBetween: 17.5 },
                },
                on: {},
            }),
        document.querySelector(".cart-wrapper .swiper-products-list") &&
            new Swiper(".cart-wrapper .swiper-products-list", {
                observer: !0,
                observeParents: !0,
                slidesPerView: 3,
                spaceBetween: 16,
                speed: 800,
                navigation: { prevEl: ".swiper-products-list .swiper-button-prev", nextEl: ".swiper-products-list  .swiper-button-next" },
                breakpoints: {
                    320: { slidesPerView: 1.15, spaceBetween: 10 },
                    467: { slidesPerView: 1.8, spaceBetween: 16 },
                    640: { slidesPerView: 2.8, spaceBetween: 17.5 },
                    999: { slidesPerView: 2.2, spaceBetween: 17.5 },
                    1200: { slidesPerView: 4, spaceBetween: 17.5 },
                },
                on: {},
            }),
        document.querySelector(".section__blog-post .swiper-products-list") &&
            new Swiper(".section__blog-post .swiper-products-list", {
                observer: !0,
                observeParents: !0,
                slidesPerView: 3,
                spaceBetween: 16,
                speed: 800,
                navigation: { prevEl: ".section__blog-post .swiper-products-list .swiper-button-prev", nextEl: ".section__blog-post .swiper-products-list  .swiper-button-next" },
                breakpoints: { 320: { slidesPerView: 1.15, spaceBetween: 10 }, 467: { slidesPerView: 1.8, spaceBetween: 16 }, 640: { slidesPerView: 2.8, spaceBetween: 17.5 }, 991: { slidesPerView: 2.8, spaceBetween: 17.5 } },
                on: {},
            }),
        document.querySelector(".image-with-text__slider-target.swiper") &&
            new Swiper(".image-with-text__slider-target.swiper", {
                observer: !0,
                observeParents: !0,
                slidesPerView: 1,
                spaceBetween: 16,
                autoHeight: !0,
                speed: 800,
                pagination: { el: ".slider-dots", clickable: !0 },
                navigation: { prevEl: ".image-with-text__slider .slider-arrow.prev", nextEl: ".image-with-text__slider .slider-arrow.next" },
                on: {},
            });
}
window.addEventListener("load", function (e) {

    var t = window.innerWidth;
    t <= mediaQuerySize && sliderTagInit(), t <= mediaQuerySize && sliderProductInit(), t <= mediaQuerySize && sliderIconsInit(), t <= mediaQuerySizeLarge && sliderOffersInit(), initSliders();
  //  let checkedBulk = document.querySelector(".product-bulkdiscount input:checked");
  // if(checkedBulk){
  //   const priceWrapper = document.querySelector(".product-form .priceWrapper");
  //   const regularPrice = priceWrapper.dataset.rawPrice;
  //   const comparePrice = priceWrapper.dataset.rawComparePrice;
  //   const productBulkInputValue = checkedBulk.value;
  //   const currentBulkPrice = document.querySelector('body').classList.contains("v2") ? parseInt(checkedBulk.querySelector('.product-bulkdiscount--item-value').innerText.replace(",", "")) * productBulkInputValue : parseInt(checkedBulk.querySelectorAll('.product-bulkdiscount--item-value span')[0].innerText.replace(",", ""));
  //   if(comparePrice){
  //       const comparePriceWrapper = priceWrapper.querySelector(".price.price--compare");
  //       const regularPriceWrapper = priceWrapper.querySelector(".price.price--highlight");
  //       comparePriceWrapper.innerHTML = `<span class="visually-hidden">Regular price</span>${(regularPrice / 100 * productBulkInputValue).toFixed(2).toString().replace(".",",")}`
  //       regularPriceWrapper.innerHTML = `<span class="visually-hidden">Sale price</span>${(currentBulkPrice / 100 ).toFixed(2).toString().replace(".",",")}`
        
  //     } else{
  //       const regularPriceWrapper = priceWrapper.querySelector(".price");
  //       regularPriceWrapper.innerHTML = `<span class="visually-hidden">Sale price</span>${(currentBulkPrice / 100 ).toFixed(2).toString().replace(".",",")}`
  //     }
  // }

   }),

window.addEventListener("resize", function (e) {
        var t = window.innerWidth;
        t <= mediaQuerySize ? sliderTagInit() : sliderTagDestroy(),
            t <= mediaQuerySize ? sliderProductInit() : sliderProductDestroy(),
            t <= mediaQuerySize ? sliderIconsInit() : sliderIconsDestroy(),
            t <= mediaQuerySizeLarge ? sliderOffersInit() : sliderOffersDestroy();
    });
document.addEventListener("DOMContentLoaded", function () {
  const productBulk = document.querySelector(".product-bulkdiscount");
  if(productBulk){
    const quantityInput = document.querySelector(".quantity-selector.quantity-selector--product input")
    const priceWrapper = document.querySelector(".product-form .priceWrapper");
    const regularPrice = priceWrapper.dataset.rawPrice;
    const comparePrice = priceWrapper.dataset.rawComparePrice;
    
    
    productBulk.addEventListener("click", function (e) {
	if(e.target.closest(".product-bulkdiscount--cell")){
      const currentBulk = e.target.closest(".product-bulkdiscount--cell");
      const productBulkInputValue = currentBulk.querySelector('input').value
      quantityInput.value = productBulkInputValue;
      let currentBulkPrice = document.querySelector('body').classList.contains("v2") ? parseInt(currentBulk.querySelector('.product-bulkdiscount--item-value').innerText.replace(",", "")) * productBulkInputValue : parseInt(currentBulk.querySelectorAll('.product-bulkdiscount--item-value span')[0].innerText.replace(",", ""));
      if(!currentBulkPrice){
          currentBulkPrice = regularPrice; 
      }
      if(document.querySelector('body').classList.contains("template-v3")){
        
      
      if(comparePrice){
        const comparePriceWrapper = priceWrapper.querySelector(".price.price--compare");
        const regularPriceWrapper = priceWrapper.querySelector(".price.price--highlight");
        comparePriceWrapper.innerHTML = currentBulkPrice===regularPrice ? `<span class="visually-hidden">Regular price</span>${(comparePrice / 100 * productBulkInputValue).toFixed(2).toString().replace(".",",")}` : `<span class="visually-hidden">Regular price</span>${(regularPrice / 100 * productBulkInputValue).toFixed(2).toString().replace(".",",")}`;
        regularPriceWrapper.innerHTML = `<span class="visually-hidden">Sale price</span>${(currentBulkPrice / 100 ).toFixed(2).toString().replace(".",",")}`
       
        if((regularPrice / 100 * productBulkInputValue) === (currentBulkPrice / 100)){
                  comparePriceWrapper.innerHTML = `<span class="visually-hidden">Regular price</span>${(comparePrice / 100 * productBulkInputValue).toFixed(2).toString().replace(".",",")}`;
        }
      } else{
        const regularPriceWrapper = priceWrapper.querySelector(".price");
        regularPriceWrapper.innerHTML = `<span class="visually-hidden">Sale price</span>${(currentBulkPrice / 100 ).toFixed(2).toString().replace(".",",")}`
      }
      }
    }
});
  }

  const judgemeButton = document.querySelector('#judgeme_product_reviews .jdgm-write-rev-link')
  if(judgemeButton){
    judgemeButton.addEventListener("click", function (e) {
    
      document.querySelector('.popup-open-link').click();
      const judgemeForm = document.querySelector('#judgeme_product_reviews .jdgm-form');
      const judgemeFormName = judgemeForm.querySelector('input[name="reviewer_name"]');
      const judgemeFormEmail = judgemeForm.querySelector('input[name="reviewer_email"]');
      const judgemeFormScore = judgemeForm.querySelector('input[name="score"]');
      const judgemeFormTitle = judgemeForm.querySelector('input[name="review_title"]');
      const judgemeFormBody = judgemeForm.querySelector('textarea[name="review_body"]');
      const judgemeFormPhoto = judgemeForm.querySelector('input[name="pictures"]');
      const judgemeFormVideo = judgemeForm.querySelector('input[name="video"]');
      const judgemeFormSubmit = judgemeForm.querySelector('input[type="submit"]');

      const popupForm = document.querySelector('#review-form .review-form__body');
      const productID = popupForm.dataset.product;
      const popupFormName = popupForm.querySelector('input[name="reviewer_name"]');
      const popupFormEmail = popupForm.querySelector('input[name="reviewer_email"]');
      const popupFormScore = popupForm.querySelector('.rating');
      const popupFormTitle = popupForm.querySelector('textarea[name="review_title"]');
      const popupFormBody = popupForm.querySelector('input[name="review_body"]');
      const popupFormPhoto = popupForm.querySelector('input[name="pictures"]');
      const popupFormVideo = popupForm.querySelector('input[name="video"]');
      const popupFormSubmit = popupForm.querySelector('.review-form__submit');

      if (popupFormPhoto) {
         const photoItems = popupForm.querySelector(".review-form__pictures");
      
        let files;
      
       popupFormPhoto.addEventListener("change", function () {
          //getting user select file and [0] this means if user select multiple files then we'll select only the first one
          files = this.files;
        
          showFile(); //calling function
        });
      
        function showFile() {
          let file;
          const dataTransfer = new DataTransfer();
          for (let i = 0; i < files.length; i++) {
            file = files[i];
            let fileType = file.type; //getting selected file type
            let validExtensions = ["image/jpeg", "image/jpg", "image/png","image/webp", "image/gif"]; //adding some valid image extensions in array
            if (validExtensions.includes(fileType)) {
              let fileName = file.name;
              //if user selected file is an image file
              let fileReader = new FileReader(); //creating new FileReader object
              fileReader.onload = () => {
                let fileURL = fileReader.result; //passing user file source in fileURL variable
                let imgItem = ` <div data-name='${fileName}' class="addphoto__item">
          	 							 <div class="addphoto__image-ibg">
          		 							<img src="${fileURL}" alt="review" />
          	 							 </div>
          	 							 <div class="addphoto__body">
          									 <div class="addphoto__close">
                    <svg
            focusable="false"
            viewBox="0 0 19 19"
            role="presentation">
            <path
              d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z"
              fill="currentColor"
              fill-rule="evenodd"></path>
          </svg></div>
                                          </div>
          								</div>`;
                photoItems.insertAdjacentHTML("beforeend", imgItem);
              };
              fileReader.readAsDataURL(file);
             
              dataTransfer.items.add(file);
            } else {
              alert("This is not an Image File!");
            }
          }
          const fileList = dataTransfer.files;
          judgemeFormPhoto.files = fileList;
          
        }
        //Delete Item
        photoItems.addEventListener("click", deleteItem);
      
        function deleteItem(e) {
          if (e.target.closest(".addphoto__close")) {
            const close = e.target.closest(".addphoto__close");
            const currentPhoto = close.closest(".addphoto__item");
            currentPhoto.remove();
            const photoName = currentPhoto.dataset.name;
            const dt = new DataTransfer();
            const { files } = judgemeFormPhoto;
            for (let i = 0; i < files.length; i++) {
                const file = files[i];  
                if (file.name !== photoName) {
                  dt.items.add(file); // here you exclude the file. thus removing it.
                }
              }
        
        /* Assigning data transfer object files to the 'input' variable will not write the data transfer files to it because it doesn't have the reference to the element: Instead write, */
        judgemeFormPhoto.files = dt.files; // Assign the updates list
        popupFormPhoto.files = dt.files
          }
        }
      }
      if (popupFormVideo) {
         const videoItems = popupForm.querySelector(".review-form__video");
      
        let files;
      
        popupFormVideo.addEventListener("change", function () {
          //getting user select file and [0] this means if user select multiple files then we'll select only the first one
          files = this.files;
          //  dropArea.classList.add("active");
          showFile(); //calling function
        });
      
        function showFile() {
          let file;
          const dataTransfer = new DataTransfer();
          for (let i = 0; i < files.length; i++) {
            file = files[i];
      
            let fileType = file.type; //getting selected file type
            // let validExtensions = ["video/mov","video/mp4","video/x-m4v","video/*"]; //adding some valid image extensions in array
            // if (validExtensions.includes(fileType)) {
            if (true) {
              //if user selected file is an image file
              let fileReader = new FileReader(); //creating new FileReader object
               let fileName = file.name;
              fileReader.onload = () => {
                let fileURL = fileReader.result; //passing user file source in fileURL variable
                
                let imgItem = ` <div data-name="${fileName}" class="addphoto__item">
                <?xml version="1.0" encoding="iso-8859-1"?>
                    <svg class="addphoto__item-video-bg" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    	 viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
                    <g>
                    	<path style="fill:#010002;" d="M24,14.059V5.584L18.414,0H0v32h24v-0.059c4.499-0.5,7.998-4.31,8-8.941
                    		C31.998,18.366,28.499,14.557,24,14.059z M17.998,2.413L21.586,6h-3.588C17.998,6,17.998,2.413,17.998,2.413z M2,30V1.998h14v6.001
                    		h6v6.06c-0.693,0.076-1.361,0.238-2,0.464V12H8v3l-4-3v10l4-3v3h6.059C14.022,22.329,14,22.661,14,23c0,2.829,1.308,5.352,3.35,7H2
                    		z M23,29.883c-3.801-0.009-6.876-3.084-6.885-6.883c0.009-3.801,3.084-6.876,6.885-6.885c3.799,0.009,6.874,3.084,6.883,6.885
                    		C29.874,26.799,26.799,29.874,23,29.883z"/>
                    	<path style="fill:#010002;" d="M19,27h3l-3-3V27z M19.999,23l5-5L28,21l-5,5L19.999,23z"/>
                    </g>
                    </svg>
      
          	 							 <div class="addphoto__image-ibg">
          		 							
                    <video src="${fileURL}"></video>
          	 							 </div>
          	 							 <div class="addphoto__body">
          									 <div class="addphoto__close">
                    <svg
            focusable="false"
            viewBox="0 0 19 19"
            role="presentation">
            <path
              d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z"
              fill="currentColor"
              fill-rule="evenodd"></path>
          </svg></div>
                                          </div>
          								</div>`;
                videoItems.insertAdjacentHTML("beforeend", imgItem);
                const videoInputLabel = videoItems.querySelector('.review-form__row--media-video') 
                videoInputLabel.style.display="none";
              };
              fileReader.readAsDataURL(file);
               dataTransfer.items.add(file);
            } else {
              alert("This is not an Video File!");
            }
          }
          const fileList = dataTransfer.files;
          judgemeFormVideo.files = fileList;
        }
        //Delete Item
        videoItems.addEventListener("click", deleteItemVideo);
      
        function deleteItemVideo(e) {
          if (e.target.closest(".addphoto__close")) {
            const close = e.target.closest(".addphoto__close");
            const currentPhoto = close.closest(".addphoto__item");
            currentPhoto.remove();
            const videoInputLabel = videoItems.querySelector('.review-form__row--media-video') 
            videoInputLabel.style.display="inline-block";
            const photoName = currentPhoto.dataset.name;
            const dt = new DataTransfer();
            const { files } = judgemeFormVideo;
            for (let i = 0; i < files.length; i++) {
                const file = files[i];  
                if (file.name !== photoName) {
                  dt.items.add(file); // here you exclude the file. thus removing it.
                }
              }
        /* Assigning data transfer object files to the 'input' variable will not write the data transfer files to it because it doesn't have the reference to the element: Instead write, */
        judgemeFormVideo.files = dt.files; // Assign the updates list
        popupFormVideo.files = dt.files
          }
        }
      }
      
// //Add video
// const videoButton = document.querySelector(".addvideo__button");
// if (videoButton) {
//   const videoRow = videoButton.closest(".phototype-advertisement__addvideo");
//   const videoInput = videoRow.querySelector(".addvideo__input");

//   videoButton.addEventListener("click", function (e) {
//     if (
//       videoInput.value !== " " &&
//       videoRow.classList.contains("_video-active")
//     ) {
//       let videoLink = videoInput.value;
//       if (validateYouTubeUrl(videoLink)) {
//         const linkId = getYoutubeUrlId(videoLink);
//         let videoBlock = `  <div class="addvideo__video-block">
//         <div class="addvideo__close _icon-close"></div>
//         <iframe
// 		   src="https://www.youtube.com/embed/${linkId}"
//       	 title="YouTube video player"
//       	 frameborder="0"
//       	 allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
//       	 allowfullscreen
//         ></iframe>
//       </div>`;
//         videoRow.insertAdjacentHTML("beforeend", videoBlock);
//       }

//       videoRow.insertAdjacentHTML("beforeend", videoBlock);
//     }

//     function getYoutubeUrlId(url) {
//       const urlObject = new URL(url);
//       let urlOrigin = urlObject.origin;
//       let urlPath = urlObject.pathname;

//       if (urlOrigin.search("youtu.be") > -1) {
//         return urlPath.substr(1);
//       }
//       if (urlPath.search("embed") > -1) {
//         return urlPath.substr(7);
//       }
//       return urlObject.searchParams.get("v");
//     }

//     videoRow.classList.add("_video-active");
//     videoButton.innerHTML = "Завантажити";
//   });
//   function validateYouTubeUrl(urlToParse) {
//     if (urlToParse) {
//       var regExp =
//         /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
//       if (urlToParse.match(regExp)) {
//         return true;
//       }
//     }
//     return false;
//   }

//   videoRow.addEventListener("click", function (e) {
//     if (e.target.closest(".addvideo__close")) {
//       const videoBlock = videoRow.querySelector(".addvideo__video-block");
//       videoBlock.remove();
//     }
//   });
// }

  formFieldsInit({
	viewPass: false,
	autoHeight: false
});
      
      popupFormSubmit.addEventListener("click", function (e) {
      const error = formValidate.getErrors(popupForm);
     if (error === 0 && popupFormScore.getAttribute("title")) {
			judgemeFormName.value = popupFormName.value;
			judgemeFormEmail.value = popupFormEmail.value;
			judgemeFormScore.value = popupFormScore.getAttribute("title");
			judgemeFormTitle.value = popupFormTitle.value;
			judgemeFormBody.value = popupFormBody.value;
				setTimeout(() => {
				judgemeFormSubmit.click();
			}, 50);
			setTimeout(() => {
				judgemeFormSubmit.click();
			}, 50);
		}
      })
    })
    
  }

 
})


function formFieldsInit(options = { viewPass: false, autoHeight: false }) {
	document.body.addEventListener("focusin", function (e) {
		const targetElement = e.target;
		if ((targetElement.tagName === 'INPUT' || targetElement.tagName === 'TEXTAREA')) {
			if (!targetElement.hasAttribute('data-no-focus-classes')) {
				targetElement.classList.add('_form-focus');
				targetElement.parentElement.classList.add('_form-focus');
			}
			formValidate.removeError(targetElement);
			targetElement.hasAttribute('data-validate') ? formValidate.removeError(targetElement) : null;
		}
	});
	document.body.addEventListener("focusout", function (e) {
		const targetElement = e.target;
		if ((targetElement.tagName === 'INPUT' || targetElement.tagName === 'TEXTAREA')) {
			if (!targetElement.hasAttribute('data-no-focus-classes')) {
				targetElement.classList.remove('_form-focus');
				targetElement.parentElement.classList.remove('_form-focus');
			}
			// Миттєва валідація
			targetElement.hasAttribute('data-validate') ? formValidate.validateInput(targetElement) : null;
		}
	});
	// Якщо увімкнено, додаємо функціонал "Показати пароль"
	if (options.viewPass) {
		document.addEventListener("click", function (e) {
			let targetElement = e.target;
			if (targetElement.closest('[class*="__viewpass"]')) {
				let inputType = targetElement.classList.contains('_viewpass-active') ? "password" : "text";
				targetElement.parentElement.querySelector('input').setAttribute("type", inputType);
				targetElement.classList.toggle('_viewpass-active');
			}
		});
	}
	// Якщо увімкнено, додаємо функціонал "Автовисота"
	if (options.autoHeight) {
		const textareas = document.querySelectorAll('textarea[data-autoheight]');
		if (textareas.length) {
			textareas.forEach(textarea => {
				const startHeight = textarea.hasAttribute('data-autoheight-min') ?
					Number(textarea.dataset.autoheightMin) : Number(textarea.offsetHeight);
				const maxHeight = textarea.hasAttribute('data-autoheight-max') ?
					Number(textarea.dataset.autoheightMax) : Infinity;
				setHeight(textarea, Math.min(startHeight, maxHeight))
				textarea.addEventListener('input', () => {
					if (textarea.scrollHeight > startHeight) {
						textarea.style.height = `auto`;
						setHeight(textarea, Math.min(Math.max(textarea.scrollHeight, startHeight), maxHeight));
					}
				});
			});
			function setHeight(textarea, height) {
				textarea.style.height = `${height}px`;
			}
		}
	}
}
// Валідація форм
let formValidate = {
	getErrors(form) {
		let error = 0;
		let formRequiredItems = form.querySelectorAll('*[data-required]');
		if (formRequiredItems.length) {
			formRequiredItems.forEach(formRequiredItem => {
				if (!formRequiredItem.disabled) {
					error += this.validateInput(formRequiredItem);
				}
			});
		}
		return error;
	},
	validateInput(formRequiredItem) {
		let error = 0;
		if (formRequiredItem.dataset.required === "email") {
			formRequiredItem.value = formRequiredItem.value.replace(" ", "");
			if (this.emailTest(formRequiredItem)) {
				this.addError(formRequiredItem);
				error++;
			} else {
				this.removeError(formRequiredItem);
			}
		} else if (formRequiredItem.type === "checkbox" && !formRequiredItem.checked) {
			this.addError(formRequiredItem);
			error++;
		} else {
			if (!formRequiredItem.value.trim()) {
				this.addError(formRequiredItem);
				error++;
			} else {
				this.removeError(formRequiredItem);
			}
		}
		return error;
	},
	addError(formRequiredItem) {
		formRequiredItem.classList.add('_form-error');
		formRequiredItem.parentElement.classList.add('_form-error');
		let inputError = formRequiredItem.parentElement.querySelector('.form__error');
		if (inputError) formRequiredItem.parentElement.removeChild(inputError);
		if (formRequiredItem.dataset.error) {
			formRequiredItem.parentElement.insertAdjacentHTML('beforeend', `<div class="form__error">${formRequiredItem.dataset.error}</div>`);
		}
      let tabBody = formRequiredItem.closest(".tabs__body");
      if(tabBody){
         let tabBodyIndex = tabBody.dataset.index;
        let currentForm = formRequiredItem.closest("form");
        let tabNavigation = currentForm.querySelector(`.tabs__title[data-index="${tabBodyIndex}"]`);
        if(!tabNavigation.classList.contains("title-error") && !tabNavigation.classList.contains("_tab-active")){
          tabNavigation.classList.add("title-error")
        }
        setTimeout(() => {
        	tabNavigation.classList.contains("title-error") ? tabNavigation.classList.remove("title-error") : null;
        }, 3000);
        }
      
      
	},
	removeError(formRequiredItem) {
		formRequiredItem.classList.remove('_form-error');
		formRequiredItem.parentElement.classList.remove('_form-error');
		if (formRequiredItem.parentElement.querySelector('.form__error')) {
			formRequiredItem.parentElement.removeChild(formRequiredItem.parentElement.querySelector('.form__error'));
		}
      //  let tabBody = formRequiredItem.closest(".tabs__body");
      // if(tabBody){
      //    let tabBodyIndex = tabBody.dataset.index;
      //   let currentForm = formRequiredItem.closest("form");
      //   let tabNavigation = currentForm.querySelector(`.tabs__title[data-index="${tabBodyIndex}"]`);
      //   tabNavigation.classList.contains("title-error") ? tabNavigation.classList.remove("title-error") : null;
      // }
	},
	formClean(form) {
		form.reset();
		setTimeout(() => {
			let inputs = form.querySelectorAll('input,textarea');
			for (let index = 0; index < inputs.length; index++) {
				const el = inputs[index];
				el.parentElement.classList.remove('_form-focus');
				el.classList.remove('_form-focus');
				formValidate.removeError(el);
			}
			let checkboxes = form.querySelectorAll('.checkbox__input');
			if (checkboxes.length > 0) {
				for (let index = 0; index < checkboxes.length; index++) {
					const checkbox = checkboxes[index];
					checkbox.checked = false;
				}
			}
			
		}, 0);
	},
	emailTest(formRequiredItem) {
		return !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/.test(formRequiredItem.value);
	}
}
// /* Відправлення форм */
// function formSubmit() {
// 	const forms = document.forms;
// 	if (forms.length) {
// 		for (const form of forms) {
// 			form.addEventListener('submit', function (e) {
// 				const form = e.target;
// 				formSubmitAction(form, e);
// 			});
// 			form.addEventListener('reset', function (e) {
// 				const form = e.target;
// 				formValidate.formClean(form);
// 			});
// 		}
// 	}
// 	async function formSubmitAction(form, e) {
// 		const error = !form.hasAttribute('data-no-validate') ? formValidate.getErrors(form) : 0;
// 		if (error === 0) {
// 			const ajax = form.hasAttribute('data-ajax');
// 			if (ajax) { // Якщо режим ajax
// 				e.preventDefault();
// 				const formAction = form.getAttribute('action') ? form.getAttribute('action').trim() : '#';
// 				const formMethod = form.getAttribute('method') ? form.getAttribute('method').trim() : 'GET';
// 				const formData = new FormData(form);

// 				form.classList.add('_sending');
// 				const response = await fetch(formAction, {
// 					method: formMethod,
// 					body: formData
// 				});
// 				if (response.ok) {
// 					let responseResult = await response.json();
// 					form.classList.remove('_sending');
// 					formSent(form, responseResult);
// 				} else {
// 					alert("Помилка");
// 					form.classList.remove('_sending');
// 				}
// 			} else if (form.hasAttribute('data-dev')) {	// Якщо режим розробки
// 				e.preventDefault();
// 				formSent(form);
// 			}
// 		} else {
// 			e.preventDefault();
// 			if (form.querySelector('._form-error') && form.hasAttribute('data-goto-error')) {
// 				const formGoToErrorClass = form.dataset.gotoError ? form.dataset.gotoError : '._form-error';
// 				gotoBlock(formGoToErrorClass, true, 1000);
// 			}
// 		}
// 	}
// 	// Дії після надсилання форми
// 	function formSent(form, responseResult = ``) {
// 		// Створюємо подію відправлення форми
// 		document.dispatchEvent(new CustomEvent("formSent", {
// 			detail: {
// 				form: form
// 			}
// 		}));
// 		// Показуємо попап, якщо підключено модуль попапів 
// 		// та для форми вказано налаштування
// 		setTimeout(() => {
// 			if (flsModules.popup) {
// 				const popup = form.dataset.popupMessage;
// 				popup ? flsModules.popup.open(popup) : null;
// 			}
// 		}, 0);
// 		// Очищуємо форму
// 		formValidate.formClean(form);
// 		// Повідомляємо до консолі
		
// 	}
	
// }

